// extracted by mini-css-extract-plugin
export var text = "_bs-0";